module.exports = __webpack_public_path__ + "static/media/green_animal_insects_6.dfbc8de3.webp";